import React from "react";
import { Meeting } from "../../types/Meeting.tsx";
import dayjs from "dayjs";

interface ConfirmationModalProps {
  isOpen: boolean;
  meeting: Meeting;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  meeting,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[300] bg-black bg-opacity-40 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-auto p-4 sm:p-6">
        <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-4">
          Confirm AI Invite Generation
        </h3>
        
        <p className="text-sm sm:text-base text-gray-600 mb-4">
          Are you sure you want to use this meeting to generate an AI social invitation?
        </p>

        {/* Meeting Info */}
        <div className="bg-gray-50 rounded-lg p-3 sm:p-4 mb-6">
          <div className="space-y-2 sm:space-y-3">
            <div className="flex flex-col sm:flex-row">
              <span className="font-semibold text-gray-700 text-sm sm:text-base">Meeting:</span>
              <span className="sm:ml-2 text-sm sm:text-base break-words">{meeting.topic || 'No Title'}</span>
            </div>
            <div className="flex flex-col sm:flex-row">
              <span className="font-semibold text-gray-700 text-sm sm:text-base">ID:</span>
              <span className="sm:ml-2 font-mono text-xs sm:text-sm break-all">{meeting.meetingId || 'N/A'}</span>
            </div>
            <div className="flex flex-col sm:flex-row">
              <span className="font-semibold text-gray-700 text-sm sm:text-base">Date:</span>
              <span className="sm:ml-2 text-sm sm:text-base">
                {meeting.startDate ? dayjs(meeting.startDate).format("MMM DD, YYYY hh:mm A") : 'No Date'}
              </span>
            </div>
            {meeting.description && (
              <div className="flex flex-col sm:flex-row">
                <span className="font-semibold text-gray-700 text-sm sm:text-base">Description:</span>
                <span className="sm:ml-2 text-sm sm:text-base break-words">{meeting.description}</span>
              </div>
            )}
          </div>
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:justify-end">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-600 hover:text-gray-800 font-medium text-sm sm:text-base order-2 sm:order-1"
          >
            No, Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors text-sm sm:text-base order-1 sm:order-2"
          >
            Yes, Generate Invite
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;